import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import pick from 'lodash/pick';
import PaymentMethodForm from './PaymentMethodForm';

// import { Link } from 'react-router-dom';
import {
  Modal,
  ModalBody
} from 'reactstrap';
import ModalHeader from '../reactstrap/ModalHeader';

import { updateSubscriptionSuccess, loadProject, updateProfileSuccess } from '../../actions';
import { Account } from '../../api';


const mapStateToProps = state => ({ currentProject: state.currentProject });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({ updateSubscriptionSuccess, loadProject, updateProfileSuccess }, dispatch)
};


const modalPropKeys = Object.keys(Modal.propTypes);

class AddPaymentMethodModal extends Component {
  
  constructor (props){
    super(props)

    this.startLoading = this.startLoading.bind(this)
    this.stopLoading = this.stopLoading.bind(this)
    this.onPaymentMethodSuccess = this.onPaymentMethodSuccess.bind(this);
    this.state = {
      loading: false
    }
  }
  
  startLoading (){
    this.setState({loading: true})
  }
  stopLoading (){
    this.setState({loading: false})
  }
  
  onPaymentMethodSuccess (params){
    // this.setState({token:params});
    const { toggle, updateProfileSuccess } = this.props;
    this.startLoading();
    
    Account.updatePaymentMethod({source: params}).then(updateProfileSuccess).then(toggle, this.stopLoading)
  }
  
  render() {
    const { currentProject, toggle, ...otherProps } = this.props;
    const modalProps = pick(otherProps, modalPropKeys);
    
    return (
      <Modal {...modalProps} centered={true}>
        <ModalHeader toggle={toggle} className="text-center">Add Payment Method</ModalHeader>
        <ModalBody className="activate-modal">
          <PaymentMethodForm onSuccess={this.onPaymentMethodSuccess} loading={this.state.loading} submitText="Add Card" />
        </ModalBody>
      </Modal>
    );
  }
  
}

export default connect(mapStateToProps, matchDispatchToProps)(AddPaymentMethodModal);


// WEBPACK FOOTER //
// ./src/components/billing/addPaymentMethodModal.js